import { AssessmentRoute } from '@/features/assessment/AssessmentRoute'
import { ForgetResumeDecisionWhenSignedOut } from '@/features/onboarding-chat/components/ForgetResumeDecisionWhenSignedOut'
import { LoginGate } from '@/features/onboarding-chat/components/LoginGate'
import { AuthProvider, useAuth } from '@/lib/context/auth-context'

function OperatorAssessment() {
  const { user } = useAuth()
  return <AssessmentRoute ownerKey={user?.email ?? null} />
}

/** /onboarding/assessment: the Growth Score page, behind the same operator sign-in as the chat. */
export default function AssessmentPage() {
  return (
    <AuthProvider>
      <ForgetResumeDecisionWhenSignedOut />
      <LoginGate>
        <OperatorAssessment />
      </LoginGate>
    </AuthProvider>
  )
}
